import { useState, forwardRef, useImperativeHandle } from 'react';
import Dialog from '@/components/Dialog';

interface DialogCharacterCompassDetailProps {
  detail: {
    emoji: string;
    title: string;
    description: string;
  };
}

export interface DialogCharacterCompassDetailRef {
  openDialog: () => void;
  closeDialog: () => void;
}

const DialogCharacterCompassDetail = forwardRef<DialogCharacterCompassDetailRef, DialogCharacterCompassDetailProps>(
  ({ detail }, ref) => {
    const [open, setOpen] = useState(false);
    const { emoji, title, description } = detail || {};

    useImperativeHandle(ref, () => ({
      openDialog: () => setOpen(true),
      closeDialog: () => setOpen(false),
    }));

    return (
      <Dialog
        open={open}
        setOpen={setOpen}
        title={' '}
        body={
          <div className="flex flex-col items-center justify-center gap-sh-15">
            <img className="size-12" src={emoji} alt="emotion" />
            <p className="text-sh-20-28 font-bold">{title}</p>
            <p className="text-sh-xxs">{description}</p>
          </div>
        }
      />
    );
  },
);

DialogCharacterCompassDetail.displayName = 'DialogCharacterCompassDetail';

export default DialogCharacterCompassDetail;
